import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#CE3665",
        d: "m15.603 16.841 8.4035 3.6312 16.4438-7.2623a3.99 3.99 0 0 0-.9338-.9337l-7.1066-3.0086z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#99294C",
        d: "M24.0071 42.0005h.0518c.4669 0 .8819-.1038 1.3488-.2594l13.5907-5.9654c1.1931-.5188 1.9712-1.7118 1.9712-3.0087V15.0783c0-.6744-.2075-1.2969-.5187-1.8156l-16.4438 7.2104z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#E55589",
        d: "M7.7187 13.2627c-.3113.5187-.5187 1.1412-.5187 1.7637v17.6369c0 1.2968.778 2.4899 1.9711 3.0086l13.5908 5.9654c.415.1557.83.2594 1.245.2594V20.4731z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#AF3354",
        d: "m7.7187 13.3141 8.1959 3.5793 16.807-7.4179-7.8848-3.3718C24.5775 6.052 24.37 6 24.1106 6c-.4149 0-.7781.1038-1.1931.2075l-13.85 5.8617c-.5707.3112-1.0376.7262-1.3488 1.2449"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#6D0F31",
        d: "M13.8394 31.0551v-5.4467h1.2968v5.4467z"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#6D0F31",
        d: "m16.1738 27.1125-3.2161-1.4006V24.415l3.2161 1.3488zm.0003 5.0312L12.958 30.795v-1.3487l3.2161 1.4006z"
    }, "5")
], "AppInventory", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
